import { useEffect, useState } from "react";
import {
  getGasConsumptionData,
  getGasLNGImportData,
  getGasProductionData,
} from "../../../Rest_api/RestApi";
import {
  GasConsumptionData,
  ConsumptionProductionData,
  ProductionData,
} from "../../../models/gas";
import {
  ChartDataParams,
  FormatChartData,
  FormatChartDataWithAverages,
  ProcessChartData,
} from "../../../components/recharts/functions";
import { ReMixChart } from "../../../components/recharts/ReMixCharts";
import { ChartType } from "../../../models/chart_model";
import { renderQuarterTick } from "../../../components/recharts/components";
import FilterMenu from "../../../components/FilterMenu";
import {
  getFiscalYear,
  GetNumberOfDaysInMonth,
  getQuarter,
} from "../../../extensions/date";
import {
  CHART_TYPES,
  GAS_BAR_GAP,
  GAS_PRODUCTION_TYPE,
  getAvailableMonths,
  getGasColors,
  INTERVALS,
} from "./Gas_Const";
import { stringToConsistentColor } from "../../../extensions/string";
import { SearchBox } from "../../../components/Search";

const GROUP_BY = [
  { key: "sector__sector_name", label: "Sector" },
  { key: "consumption", label: "Consumption Type" },
];
const keys = [
  {
    key: "month",
    label: "Month",
  },
];

const CONSUMPTION = [
  { value: "domestic_consumption_mmscmd", label: "Domestic Consumption" },
  { value: "rlng_consumption_mmscmd", label: "RLNG Consumption" },
  { value: "total_consumption_mmscmd", label: "Total Consumption" },
];
const CONSUMPTION_TABS = [
  { value: [CONSUMPTION[2]], label: "Total Consumption" },
  {
    value: [CONSUMPTION[0], CONSUMPTION[1]],
    label: "Domestic & RLNG Consumption",
  },
];
export function ConsumptionProduction() {
  const [consumptionData, setConsumptionData] = useState<
    ConsumptionProductionData[]
  >([]);
  const [selectedMonthYear, setSelectedMonthYear] = useState<any[]>([]);

  const [productionData, setProductionData] = useState<ProductionData[]>([]);
  const [chartData, setChartData] = useState<Record<string, any>[]>([]);
  const [availableMonths, setAvailableMonths] = useState<any[]>([]);

  const [selectedProduction, setSelectedProduction] = useState(
    GAS_PRODUCTION_TYPE[0],
  );
  const [importData, setImportData] = useState<ConsumptionProductionData[]>([]);
  const [chartKeys, setChartKeys] = useState({
    keys: [] as string[],
    label: [] as string[],
  });
  const [selectedChartType, setSelectedChartType] = useState(CHART_TYPES[1]);
  const [selectedConsumptionTab, setSelectedConsumptionTab] = useState(
    CONSUMPTION_TABS[1],
  );
  const [selectedKeys, setSelectedKeys] = useState<any[]>(keys);

  const [selctedConsumption, setSelectedConsumption] = useState([
    CONSUMPTION[0],
    CONSUMPTION[1],
  ]);
  const [selectedSector, setselectedSector] = useState<any[]>([]);
  const [selectedSectorType, setselectedSectorType] = useState<any[]>([]);
  useEffect(() => {
    _handlefetchData();
  }, []);
  async function _handlefetchData() {
    const production_data = await getGasProductionData({});
    setProductionData(
      production_data.map((item) => {
        const month = item.month.slice(0, 3);
        const numberOfDays = GetNumberOfDaysInMonth(month, item.year);
        return {
          ...item,
          value_mmscmd: item.value / numberOfDays,
        };
      }),
    );

    const import_data = await getGasLNGImportData({});
    setImportData(
      import_data.map((item) => {
        const month = item.month.slice(0, 3);
        const numberOfDays = GetNumberOfDaysInMonth(month, item.year);
        return {
          ...item,
          import_mmscmd: item.mmscm / numberOfDays,
          gross_production_mmscmd: 0,
          net_production_mmscmd: 0,
          domestic_consumption_mmscmd: 0,
          rlng_consumption_mmscmd: 0,
          total_consumption_mmscmd: 0,
        };
      }),
    );

    const consumptionData = await getGasConsumptionData({});
    setConsumptionData(
      consumptionData.map((item) => {
        const month = item.month.slice(0, 3);
        const numberOfDays = GetNumberOfDaysInMonth(month, item.year);
        return {
          ...item,
          domestic_consumption_mmscmd: item.domestic_consumption / numberOfDays,
          rlng_consumption_mmscmd: item.rlng_consumption / numberOfDays,
          total_consumption_mmscmd: item.total_consumption / numberOfDays,
          gross_production_mmscmd: 0,
          net_production_mmscmd: 0,
          import_mmscmd: 0,
        };
      }),
    );
    setAvailableMonths(getAvailableMonths(consumptionData));
  }
  useEffect(() => {
    let fc_data = consumptionData;
    let fp_data = productionData;
    let fi_data = importData;

    if (selectedMonthYear.length > 0) {
      fc_data = fc_data.filter((item) =>
        selectedMonthYear.map((item) => item.label).includes(item.month_year),
      );
      fp_data = fp_data.filter((item) =>
        selectedMonthYear.map((item) => item.label).includes(item.month_year),
      );
      fi_data = fi_data.filter((item) =>
        selectedMonthYear.map((item) => item.label).includes(item.month_year),
      );
    }
    const production_par: ChartDataParams = {
      keys: selectedKeys.map((item) => item.key),
      groupBy: ["production_type__production_type"],
      volumeKey: "value",
      priceKey: "",
      aggregationKeys: ["value_mmscmd"],
      data: fp_data,
    };

    const c_data: ConsumptionProductionData[] = fc_data;
    const p_data: ConsumptionProductionData[] = FormatChartData(
      production_par,
    ).data.map((item) => {
      return {
        ...item,
        domestic_consumption_mmscmd: 0,
        rlng_consumption_mmscmd: 0,
        total_consumption_mmscmd: 0,
        import_mmscmd: 0,
        gross_production_mmscmd: item[
          "Gross Production_value_mmscmd"
        ] as number,
        net_production_mmscmd: item["Net Production_value_mmscmd"] as number,
      } as ConsumptionProductionData;
    });
    const final_data_parL: ChartDataParams = {
      keys: selectedKeys.map((item) => item.key),
      groupBy: [],
      aggregationKeys: [
        "rlng_consumption_mmscmd",
        "total_consumption_mmscmd",
        "gross_production_mmscmd",
        "net_production_mmscmd",
        "import_mmscmd",
      ],
      volumeKey: "domestic_consumption_mmscmd",
      priceKey: "",
      data: c_data.concat(p_data).concat(fi_data),
    };
    const final_data = ProcessChartData(final_data_parL as any);
    let data = final_data.data;
    if (selectedKeys.length == 1) {
      if (selectedKeys[0].key == "year") {
        const unique_month_year = consumptionData
          .map((item) => item.month_year)
          .filter((value, index, self) => self.indexOf(value) === index);
        console.log(unique_month_year);
        console.log(data);
        data = data.map((item) => {
          const monthsInYear = unique_month_year.filter((month_year) =>
            month_year.includes(item.year.toString()),
          ).length;
          return {
            ...item,
            _rlng_consumption_mmscmd:
              item._rlng_consumption_mmscmd / monthsInYear,
            _total_consumption_mmscmd:
              item._total_consumption_mmscmd / monthsInYear,
            _gross_production_mmscmd:
              item._gross_production_mmscmd / monthsInYear,
            _net_production_mmscmd: item._net_production_mmscmd / monthsInYear,
            _import_mmscmd: item._import_mmscmd / monthsInYear,
            _domestic_consumption_mmscmd:
              item._domestic_consumption_mmscmd / monthsInYear,
          };
        });
      }
      if (selectedKeys[0].key == "month") {
        const unique_month_year = consumptionData
          .map((item) => item.month_year)
          .filter((value, index, self) => self.indexOf(value) === index);
        data = data.map((item) => {
          const number_of_month = unique_month_year.filter((month_year) =>
            month_year.includes(item.month),
          ).length;
          return {
            ...item,
            _rlng_consumption_mmscmd:
              item._rlng_consumption_mmscmd /*/ number_of_month */,
            _total_consumption_mmscmd:
              item._total_consumption_mmscmd /*/ number_of_month */,
            _gross_production_mmscmd:
              item._gross_production_mmscmd /*/ number_of_month */,
            _net_production_mmscmd:
              item._net_production_mmscmd /*/ number_of_month */,
            _import_mmscmd: item._import_mmscmd /*/ number_of_month */,
            _domestic_consumption_mmscmd:
              item._domestic_consumption_mmscmd /*/ number_of_month */,
          };
        });
      } else if (selectedKeys[0].key == "fyear") {
        const unique_month_fyear = consumptionData
          .map((item) => item.month_fyear)
          .filter((value, index, self) => self.indexOf(value) === index);
        data = data.map((item) => {
          // const numberOfDays = GetNumberOfDaysInMonth(item.month, item.year);
          const monthsInYear = unique_month_fyear.filter((month_year) =>
            month_year.includes(item.fyear.toString()),
          ).length;
          return {
            ...item,
            _rlng_consumption_mmscmd:
              item._rlng_consumption_mmscmd / monthsInYear,
            _total_consumption_mmscmd:
              item._total_consumption_mmscmd / monthsInYear,
            _gross_production_mmscmd:
              item._gross_production_mmscmd / monthsInYear,
            _net_production_mmscmd: item._net_production_mmscmd / monthsInYear,
            _import_mmscmd: item._import_mmscmd / monthsInYear,
            _domestic_consumption_mmscmd:
              item._domestic_consumption_mmscmd / monthsInYear,
          };
        });
      } else if (selectedKeys[0].key == "quarter") {
        const unique_month_quarter = consumptionData
          .map((item) => item.month_quarter)
          .filter((value, index, self) => self.indexOf(value) === index);
        data = data.map((item) => {
          const monthsInYear = unique_month_quarter.filter((month_year) =>
            month_year.includes(item.quarter.toString()),
          ).length;
          return {
            ...item,
            _rlng_consumption_mmscmd:
              item._rlng_consumption_mmscmd / monthsInYear,
            _total_consumption_mmscmd:
              item._total_consumption_mmscmd / monthsInYear,
            _gross_production_mmscmd:
              item._gross_production_mmscmd / monthsInYear,
            _net_production_mmscmd: item._net_production_mmscmd / monthsInYear,
            _import_mmscmd: item._import_mmscmd / monthsInYear,
            _domestic_consumption_mmscmd:
              item._domestic_consumption_mmscmd / monthsInYear,
          };
        });
      }
    }

    setChartData(
      data.map((item) => {
        return {
          ...item,
          domestic_consumption_mmscmd: item._domestic_consumption_mmscmd,
          rlng_consumption_mmscmd: item._rlng_consumption_mmscmd,
          total_consumption_mmscmd: item._total_consumption_mmscmd,
          gross_production_mmscmd: item._gross_production_mmscmd,
          net_production_mmscmd: item._net_production_mmscmd,
          import_mmscmd: item._import_mmscmd,
        };
      }),
    );
    setChartKeys({
      keys: selectedKeys,
      label: selctedConsumption.map((item) => item.label),
    });
  }, [consumptionData, selectedKeys, selectedMonthYear]);

  const handleKeySelection = (keyIndex: number) => {
    const selectedKey = INTERVALS[keyIndex]; // The key to be toggled

    setSelectedKeys([selectedKey]);
  };
  function _handleConsumptionSelection(index: number) {
    setSelectedConsumptionTab(CONSUMPTION_TABS[index]);
    setSelectedConsumption(CONSUMPTION_TABS[index].value);
  }
  function _handleSelectedSector(item: string) {
    const isSelected = selectedSector.find((value) => value === item);
    if (isSelected) {
      setselectedSector(selectedSector.filter((value) => value !== item));
    } else {
      setselectedSector((prev) => [...prev, item]);
    }
  }

  return (
    <div className="gas-page-container">
      <div className="side-filters-container text-nowrap">
        <FilterMenu
          title="Consumption"
          items={CONSUMPTION_TABS.map((item) => {
            return item.label;
          })}
          selectedItems={[selectedConsumptionTab.label]}
          onSelect={(item, index) => {
            _handleConsumptionSelection(index);
          }}
        />

        <FilterMenu
          title="Production"
          items={GAS_PRODUCTION_TYPE.map((item) => item.label)}
          selectedItems={[selectedProduction.label]}
          onSelect={(item, index) => {
            setSelectedProduction(GAS_PRODUCTION_TYPE[index]);
          }}
        />
        <FilterMenu
          title="Chart Type"
          items={CHART_TYPES.map((item) => item.label)}
          selectedItems={[selectedChartType.label]}
          onSelect={(item, index) => {
            setSelectedChartType(CHART_TYPES[index]);
          }}
        />

        <FilterMenu
          title="Interval"
          items={INTERVALS.map((item) => item.label)}
          selectedItems={selectedKeys.map((item) => item.label)}
          onSelect={(item, index) => {
            handleKeySelection(index);
          }}
        />
      </div>
      <div className="gas-chart-container">
        <div className="gas-heading">
          <h2 className="chartHeading">
            {selectedConsumptionTab.label} Vs {selectedProduction.label} &
            Imported (MMSCMD)
          </h2>
          <SearchBox
            // unique month-year combination
            options={availableMonths}
            isMany={true}
            placeholder={
              availableMonths.length > 0
                ? `${availableMonths[0].label} to ${
                    availableMonths[availableMonths.length - 1].label
                  }`
                : "Select a date range"
            }
            selectedOptions={selectedMonthYear}
            onChange={(selected: any) => {
              setSelectedMonthYear(selected);
            }}
          />
        </div>
        <ReMixChart
          chartContainerHeight="100vh"
          data={chartData}
          barCategoryGap={GAS_BAR_GAP}
          xTick={true}
          // yAxisWidth={40}
          yAxisLabel="Volume (MMSCMD)"
          legends=//         } //             legendColor: ExchangeColors[index], //             stroke: ExchangeColors[index], //             type: ChartType.Line, //             name: key, //             dataKey: key+'_domestic_consumption', //         return { //     ...chartKeys.map((key, index) => { // [
          //     }).flat()
          // ]
          {[
            ...selctedConsumption
              .map((item, index) => {
                return {
                  dataKey: item.value,
                  stackId: selectedChartType.stackId,

                  name: item.label,
                  type: selectedChartType.value,

                  stroke: getGasColors(item.label + " Compare"),
                };
                //   });
              })
              .flat(),

            {
              dataKey: selectedProduction.value,
              stackId:
                selectedChartType.stackId != undefined
                  ? "production"
                  : undefined,
              name: selectedProduction.label,
              type: selectedChartType.value,
              stroke: getGasColors(selectedProduction.label + " Compare"),
            },

            {
              dataKey: "import_mmscmd",
              stackId: "production",
              name: "Imported",
              type: selectedChartType.value,
              stroke: getGasColors("Imported Compare"),
            },
          ]}
          xDataKey={selectedKeys[0].key}
          unit="MMSCMD"
          secondXDataKey={
            selectedKeys.length > 1 ? selectedKeys[1].key : undefined
          }
          rendexSecondXTick={(value: any) => renderQuarterTick(value, 8)}
        />
      </div>
    </div>
  );
}
